var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('footer',{staticClass:"main-footer text-center text-white"},[_c('strong',[_vm._v("© "+_vm._s(this.$sitename)+" ")]),_vm._v("~ 2021 | All rights reserved. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }